<template>
	<v-container>
		<form class="filterContainer">
			<v-alert type="error" v-show="showMandatorAlert">
				{{ txt.mandatorAlert }}
			</v-alert>
			<!-- generic alert -->
			<alert-basic
				:message="alertMessage"
				:show="showAlert"
				:type="alertType"
			/>

			<!-- Mandator -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-show="mandatorVisible"
						v-model="formState.selectedMandators"
						:items="formItems.mandator"
						:error-count="mandatorErrorCount"
						:error-messages="mandatorErrorMessage"
						hide-selected
						label="Mandator"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
			</v-row>

			<!-- Service provider -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-show="serviceProviderVisible"
						v-model="formState.selectedServiceProviders"
						:items="formItems.serviceproviders"
						hide-selected
						item-value="text"
						label="Serviceprovider"
						multiple
						persistent-hint
						chips
						return-object
					/>
				</v-col>
			</v-row>

			<!-- Date from and date till  -->
			<v-row>
				<v-col cols="12" md="12" v-show="dateFromVisible">
					<v-menu
						ref="menuFrom"
						v-model="menuFrom"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateFromTemp"
								readonly
								label="Month of export"
								v-bind="attrs"
								v-on="on"
							/>
						</template>
						<v-date-picker
							v-model="formState.dateFromFinal"
							no-title
							type="month"
							@input="menuFrom = false"
						/>
					</v-menu>
				</v-col>
			</v-row>

			<v-btn
				class="searchButton ml-5"
				color="primary"
				@click="submitFiltersBafs"
			> {{ txt.BAFSExport }}
			</v-btn>

			<v-btn
				class="searchButton ml-5"
				@click="submitFiltersTourobs"
			> {{ txt.TOUROBSExport }}
			</v-btn>

			<v-layout align-center justify-center class="dataLoading">
				<v-progress-circular
					indeterminate
					color="primary"
					v-show="loadingData"
				/>
			</v-layout>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'
import AlertBasic from '../vueBasics/AlertBasic.vue'

export default {
	name: 'StatisticsBafsTourobsFilter',
	components: {
		AlertBasic,
	},
	data() {
		return {
			txt: {
				BAFSExport: 'Export BAFS XML',
				TOUROBSExport: 'Export TOUROBS XML',
				mandatorAlert: 'Please select at least one mandator.',
			},
			// errors
			showMandatorAlert: false,

			mandatorVisible: true,
			serviceProviderVisible: true,
			dateFromVisible: true,
			dateTillVisible: true,
			formState: {
				selectedMandators: [],
				selectedServiceProviders: [],
				dateFromTemp: new Date().toISOString().substr(0, 7),
				dateFromFinal: new Date().toISOString().substr(0, 7),
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
				serviceproviders: ['Serviceproviders could not be loaded'],
			},
			mandatorErrorCount: 0,
			mandatorErrorMessage: '',

			// var for datepickers
			menuFrom: false,
			dateFromCorrect: true,
			loadingData: false,
			appNameShort: 'aastat',
			// generic alert vars
			showAlert: false,
			alertMessage: '',
			alertType: 'info',
		}
	},

	watch: {
		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
			},
		},
		'formState.dateFromFinal': {
			handler() {
				this.setDateAsFinal(this.formState.dateFromFinal)
			},
		},
		'formState.selectedMandators': {
			handler() {
				this.popFirstMandator(this.formState.selectedMandators)
				this.notEmptyMandator()
				this.getServiceprovider(this.formState.selectedMandators)
			},
		},
	},
	methods: {
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator
				this.mandatorVisible = false
			}
		},
		setDateAsFinal(dateInDatePicker) {
			this.formState.dateFromTemp = dateInDatePicker
		},
		popFirstMandator(mandators) {
			// remove the first item of the mandator array -> only one at the time
			if (mandators.length > 1) {
				this.formState.selectedMandators.shift()
			}
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
				this.showMandatorAlert = false
			}
		},

		async submitFiltersBafs() {
			this.loadingData = true
			this.showMandatorAlert = (!this.formState.selectedMandators.length > 0)
			if (this.showMandatorAlert) return
			try {
				const request = {
					dateFrom: this.formState.dateFromFinal,
					mandator: this.formState.selectedMandators[0],
					serviceProviders: this.formState.selectedServiceProviders,
				}
				const res = await axios({
					method: 'post',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/statistic-report/bafs`,
					data: request,
					responseType: 'blob',
				})
				this.loadingData = false
				// eslint-disable-next-line no-undef
				saveAs(new Blob([res.data]), 'bafs_report.zip')
			} catch (err) {
				this.loadingData = false
				this.showAlertThenHide(err.message, 'error')
				console.log(err)
			}
		},

		async submitFiltersTourobs() {
			this.loadingData = true
			this.showMandatorAlert = (!this.formState.selectedMandators.length > 0)
			if (this.showMandatorAlert) return
			try {
				const request = {
					dateFrom: this.formState.dateFromFinal,
					mandator: this.formState.selectedMandators[0],
					serviceProviders: this.formState.selectedServiceProviders,
				}
				const res = await axios({
					method: 'post',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/statistic-report/tourobs`,
					data: request,
					responseType: 'blob',
				})
				this.loadingData = false
				// eslint-disable-next-line no-undef
				saveAs(new Blob([res.data]), 'tourobs_report.zip')
			} catch (err) {
				this.loadingData = false
				this.showAlertThenHide(err.message, 'error')
				console.log(err)
			}
		},

		async getMandators() {
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/statistic-report/mandator?appNameShort=${this.appNameShort}`)
				this.$data.formItems.mandator = r.data
			} catch (e) {
				console.log(e)
				this.showAlertThenHide('Mandators could not be loaded', 'error')
			}
		},

		async getServiceprovider(selectedMandator) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/statistic-report/serviceproviders?selectedMandator=${selectedMandator[0].value}`)
				this.$data.formItems.serviceproviders = r.data
			} catch (e) {
				console.log(e)
				this.showAlertThenHide('Service providers could not be loaded', 'error')
			}
		},
		showAlertThenHide(message, type) {
			this.alertMessage = message
			this.alertType = type
			this.showAlert = true
			setTimeout(() => {
				this.showAlert = false
			}, 6000)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
		})
	},
}
</script>

<style scoped>
.filterContainer {
	padding: 0px !important;
}
</style>
